import { render, staticRenderFns } from "./sportsupdate.vue?vue&type=template&id=80a68362&scoped=true&"
import script from "./sportsupdate.vue?vue&type=script&lang=js&"
export * from "./sportsupdate.vue?vue&type=script&lang=js&"
import style0 from "./sportsupdate.vue?vue&type=style&index=0&id=80a68362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a68362",
  null
  
)

export default component.exports